import { Routes } from '@angular/router';
import { EmptyRouteComponent } from './empty-route/empty-route.component';
import { LoginComponent } from './modules/login/login.component';
import { MainComponent } from './shared/main/main.component';
import { authGuard } from './common/auth.guard';
import { CreateOrUpdateReleaseComponent } from './modules/create-or-update-release/create-or-update-release.component';
import { AddViewReleaseListComponent } from './modules/add-view-release-list/add-view-release-list/add-view-release-list.component';
import { TriggerReleaseComponent } from './modules/trigger-release/trigger-release.component';
import { RollbackMigrationListComponent } from './modules/rollback-migration/rollback-migration-list/rollback-migration-list.component';
import { AccountManagementMainComponent } from './modules/administrator/account-management-main/account-management-main.component';
import { CreateOrUpdateHotfixComponent } from './modules/create-or-update-hotfix/create-or-update-hotfix.component';
import { ReleaseDeploymentStatusDetailsComponent } from './modules/deployment-status/release-deployment-status-dtls-main/release-deployment-status-dtls.component';
import { ReleaseStatusComponent } from '@app/shared/shared-components/release-status/release-status.component';
import { ReleaseManifestStatusComponent } from './modules/release-manifest-status/release-manifest-status.component';
import { InsufficientPermissionComponent } from './insufficient-permission/insufficient-permission.component';
import { ServiceConfigurationComponent } from './modules/configuration/service-env-configuration-main/service-configuration.component';
import { EnvironmentListComponent } from './modules/environment-data/environment-list/environment-list.component';
import { HealthStatusComponent } from './modules/health-status/health-status.component';
import { AuditTrailsComponent } from './modules/create-or-update-release/audit-trails/audit-trails.component';

export const routes: Routes = [
  {
    path: 'view-branch-creation-status', component: MainComponent,
    data: {
      breadcrumb: 'Home'
    },
    children:[
       {
        path: '', component: ReleaseStatusComponent ,
        data: {
          breadcrumb: 'View Branch Creation Status'
        },
        canActivate: [authGuard('MANAGE.BRANCH.STATUS.VIEW')],
      },
    ]
  },
  {
    path: 'release', component: MainComponent,
    data: {
      breadcrumb: 'Home'
    },
    children: [
      {
        path: '', component: AddViewReleaseListComponent, 
        data: {
          breadcrumb: ''
        },
        canActivate: [authGuard('MANAGE.RELEASE')],
      },
      {
      path: 'define-releases',
      data: { breadcrumb: 'Define Releases' },
      children: [
        {
          path: 'audit-trails/:releaseId',
          component: AuditTrailsComponent,
          data: { breadcrumb: 'Audit Trail' },
          canActivate: [authGuard('MANAGE.RELEASE.AUDIT.VIEW')],
        }
      ]
    },
     {
      path: 'define-hotfix',
      data: { breadcrumb: 'Define Hotfix' },
      children: [
        {
          path: 'audit-trails/:releaseId',
          component: AuditTrailsComponent,
          data: { breadcrumb: 'Audit Trail' },
          canActivate: [authGuard('MANAGE.RELEASE.AUDIT.VIEW')],
        }
      ]
    },

      {
        path: 'create-release', component: CreateOrUpdateReleaseComponent, 
        data: {
          breadcrumb: 'Add Release'
        },
        canActivate: [authGuard('MANAGE.RELEASE.ADD')],
      },
      {
        path: 'create-hotfix/:pReleaseId', component: CreateOrUpdateHotfixComponent, 
        data: {
          breadcrumb: 'Add Hotfix Release' 
        },
        canActivate: [authGuard('MANAGE.RELEASE.ADD')],
      },
       {
        path: 'modify-hotfix/:hotfixId', component: CreateOrUpdateHotfixComponent, 
        data: {
          breadcrumb: 'Modify Hotfix Release'
        },
        canActivate: [authGuard('MANAGE.RELEASE.MODIFY')],
      },
      {
      path: 'release-deployment-dtls/:releaseId', 
      component: ReleaseDeploymentStatusDetailsComponent, 
      data: {
        breadcrumb: 'Release Deployment Details'
      },
      //canActivate: [authGuard("MANAGE.RELEASE.DEPLOYMENT.VIEW")],
    },
    {
      path: 'release-deployment-dtls/health-status/:releaseId',
      component: HealthStatusComponent,
      data: { 
        breadcrumb: 'Health Status' 
      },
      canActivate: [authGuard('MANAGE.RELEASE.DEPLOYMENT.HEALTH.STATUS')],
    },
      
      {
        path: 'modify-release/:releaseId', component: CreateOrUpdateReleaseComponent, 
        data: {
          breadcrumb: 'Modify Release'
        },
        canActivate: [authGuard('MANAGE.RELEASE.MODIFY')],
      },      
      {
        path: 'trigger-release/:releaseId', component: TriggerReleaseComponent, 
        data: {
          breadcrumb: 'Trigger Deployment'
        },
        canActivate: [authGuard('MANAGE.RELEASE.DEPLOYMENT.PIPELINE.TRIGGER')],
      },
      {
        path: 'rollback-list/:releaseId', component: RollbackMigrationListComponent, 
        data: {
          breadcrumb: 'Rollback Database'
        },
        canActivate: [authGuard('MANAGE.SYNC.DB.MIGRATION.ROLLBACK')],
      },
      {
        path: 'manage', component: AccountManagementMainComponent, 
        data: {
          breadcrumb: 'User And Role Management'
        },
        canActivate: [authGuard('MANAGE.USERS.ROLES')],
      },
      {
        path: 'services', component: ServiceConfigurationComponent, 
        data: {
          breadcrumb: 'Service and Environment Configuration'
        },
        canActivate: [authGuard(
          'MANAGE.SERVICES.ENVIRONMENTS.VIEW',
          'MANAGE.SERVICES.ENVIRONMENTS.MODIFY',
          'MANAGE.SERVICES.ENVIRONMENTS.ADD'
        )]
      },
       {
        path: 'environments', component: EnvironmentListComponent, 
        data: {
          breadcrumb: 'Environments list'
        },
        canActivate: [authGuard(
          'MANAGE.SERVICES.ENVIRONMENTS.VIEW',
          'MANAGE.SERVICES.ENVIRONMENTS.MODIFY',
          'MANAGE.SERVICES.ENVIRONMENTS.ADD'
        )]
      },
      {
        path: 'environment', component: EnvironmentListComponent, 
        data: {
          breadcrumb: 'Environment and Environment Configuration'
        },
      },
      {
        path: 'audit-trails/:releaseId', component: AuditTrailsComponent, 
        data: {
          breadcrumb: 'Audit Trail'
        },
         canActivate: [authGuard(
          'MANAGE.RELEASE.AUDIT.VIEW'
          )]
      },
      {
        path: 'manifest-status/:releaseId', component: ReleaseManifestStatusComponent, 
        data: {
          breadcrumb: 'Release Manifest Status'
        },
        canActivate: [authGuard('MANAGE.MANIFEST.STATUS.VIEW')],
      } ,
      { path: 'insufficient-permission', component: InsufficientPermissionComponent }
      
    ] },
  { path: '', component: LoginComponent },
  { path: '**', component: EmptyRouteComponent }
];

